<template>
    <div class="chat-fullscreen">
        <!-- Mobile Header -->
        <div class="mobile-header" v-if="currentChat && isMobile">
            <button class="mobile-back-btn" @click="closeMobileChat">
                <i class="fas fa-arrow-left"></i>
            </button>
            <div class="mobile-chat-info">
                <h5 class="mobile-chat-name">{{ currentChat.name }}</h5>
                <small class="mobile-chat-number">{{ currentChat.number }}</small>
            </div>
            <!-- <button class="mobile-menu-btn" @click="toggleMobileSidebar">
                <i class="fas fa-bars"></i>
            </button> -->
        </div>
        
        <div class="chat-area-fullscreen" :class="{ 'mobile-chat-open': currentChat && isMobile }">
            <div class="mb-lg-0 chat-sidebar" :class="{ 'mobile-sidebar-open': isMobileSidebarOpen }">
                <div class="sidebar-group left-sidebar chat_sidebar">
                    <div id="chat" class="left-sidebar-wrap bg-white radius-xl active">
                        <div class="chat-wrapper">
                            <div class="device-selector-header">
                                <div class="dropdown" :class="{ 'show': showDeviceDropdown }">
                                    <button class="btn btn-sm btn-outline-primary device-selector-btn-sidebar" 
                                        type="button" 
                                        id="deviceDropdownSidebar" 
                                        @click.stop="toggleDeviceDropdown"
                                        aria-haspopup="true" 
                                        :aria-expanded="showDeviceDropdown">
                                        <i class="fas fa-mobile-alt mr-1"></i>
                                        <span class="device-name-text">{{ selectedDeviceName }}</span>
                                        <i class="fas fa-chevron-down ml-1"></i>
                                    </button>
                                    <div class="dropdown-menu device-dropdown" 
                                        :class="{ 'show': showDeviceDropdown }"
                                        aria-labelledby="deviceDropdownSidebar">
                                        <h6 class="dropdown-header">Pilih Device</h6>
                                        <a v-for="d in devices" 
                                            :key="d.id" 
                                            class="dropdown-item device-item"
                                            :class="{ 'active': d.id == deviceID }"
                                            @click.stop="switchDevice(d.id)">
                                            <div class="d-flex align-items-center justify-content-between">
                                                <div>
                                                    <div class="font-weight-bold">{{ d.name }}</div>
                                                    <small class="text-muted">{{ d.phone }}</small>
                                                </div>
                                            </div>
                                        </a>
                                        <div class="dropdown-divider"></div>
                                        <router-link to="/web-whatsapp" class="dropdown-item text-center" @click.stop="showDeviceDropdown = false">
                                            <i class="fas fa-list mr-1"></i>
                                            Lihat Semua Device
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                             <div class="search-header">
                                <div class="search-input-wrapper">
                                    <i class="fas fa-search search-icon"></i>
                                    <input 
                                        class="search-input" 
                                        type="search"
                                        placeholder="Search conversations..." 
                                        aria-label="Search" 
                                        v-model.trim="searchQuery">
                                    <i v-if="searchQuery" @click="searchQuery = ''" class="fas fa-times search-clear"></i>
                                </div>
                            </div> 
                            <!-- <div class="search-tab">
                                <ul class="nav ap-tab-main border-bottom text-capitalize" id="ueberTab" role="tablist">
                                    <li class="nav-item mr-0">
                                        <a class="nav-link active" id="first-tab" data-target="#panel_b_first"
                                            data-secondary="#panel_a_first" data-toggle="tab" href="#first" role="tab"
                                            aria-controls="first-tab" aria-selected="true">private
                                            chat</a>
                                    </li>
                                </ul>
                            </div> -->
                            
                            <div class="search-body">
                                <div class="tab-content" id="ueberTabA">
                                    <div class="tab-pane fade show active" id="panel_a_first" role="tabpanel"
                                        aria-labelledby="first-tab">
                                        <ul class="user-list" v-if="!isChatListLoading" ref="chatListContainer">
                                            <li v-for="chatList in filteredChatLists" 
                                                :key="chatList.jid" 
                                                @click="openChat(chatList.jid)" 
                                                class="user-list-item" 
                                                :id="'cl-' + chatList.jid"
                                                :class="{ 'chatactive': currentChat && currentChat.jid === chatList.jid }">
                                                    <div class="user-list-item__wrapper">
                                                        <div class="avatar-wrapper">
                                                            <div class="avatar-circle">
                                                                <div class="avatar-initial">
                                                                    {{ getInitials(getName(chatList.jid, chatList.number)) }}
                                                                </div>
                                                                <span class="online-indicator"></span>
                                                            </div>
                                                        </div>
                                                        <div class="users-list-body">
                                                            <div class="users-list-body-title">
                                                                <div class="name-row">
                                                                    <h6 class="chat-name">{{ getName(chatList.jid, chatList.number) }}</h6>
                                                                    <span class="chat-time">{{ formatDateRelative(chatList.last_update) }}</span>
                                                                </div>
                                                                <div class="message-preview">
                                                                    <p class="last-message">
                                                                        <i v-if="chatList.last_chat && chatList.last_chat.file" class="fas fa-paperclip message-icon"></i>
                                                                        {{ trimString(chatList.last_chat && chatList.last_chat.text, 30) || (chatList.last_chat && chatList.last_chat.file ? (isImage(chatList.last_chat.file) ? '📷 Image' : '📄 File') : 'No messages') }}
                                                                    </p>
                                                                    <span v-if="chatList.notification" class="notification-badge">{{ chatList.notification > 99 ? '99+' : chatList.notification }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            <li v-if="hasMoreChatLists && !isLoadingMoreChats" class="load-more-trigger" ref="chatListLoadMore"></li>
                                            <li v-if="isLoadingMoreChats" class="loading-more-item">
                                                <div class="loading-spinner-small"></div>
                                                <span>Loading more...</span>
                                            </li>
                                        </ul>
                                        <div v-else class="chat-list-loading">
                                            <div class="skeleton-item" v-for="n in 5" :key="n">
                                                <div class="skeleton-avatar"></div>
                                                <div class="skeleton-content">
                                                    <div class="skeleton-line skeleton-title"></div>
                                                    <div class="skeleton-line skeleton-text"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div><!-- Ends: .search-body -->
                            <div class="sidebar-footer">
                                <router-link to="/web-whatsapp" class="btn btn-block btn-secondary sidebar-back-btn">
                                    <i class="fas fa-arrow-left mr-2"></i>
                                    Kembali
                                </router-link>
                            </div>
                        </div><!-- Ends: .chat-wrapper -->
                    </div>
                </div><!-- Ends: .sidebar group -->
            </div><!-- Ends: .mb-lg-0 -->
            <div class="tab-content chat-main-content" style="width: 100% !important" id="ueberTabB">
                <div class="tab-pane fade  show active" id="panel_b_first" role="tabpanel" aria-labelledby="first-tab">
                    <!-- Mobile Sidebar Toggle Button (when no chat selected) -->
                    <div v-if="!currentChat && isMobile" class="mobile-sidebar-toggle">
                        <button class="btn btn-primary" @click="toggleMobileSidebar">
                            <i class="fas fa-bars mr-2"></i>
                            Open Chat List
                        </button>
                    </div>
                    <div v-if="isChatLoading">
                        <div class="chat-body bg-white radius-xl">
                            <div class="chat-header">
                                <div class="media chat-name align-items-center">
                                    <div class="media-body align-self-center ">
                                        <h5 class="mb-0 fw-500 mb-2">Starsender Web Whatsapp</h5>
                                    </div>
                                </div>
                                <!-- Chat Options -->
                                <ul class="nav flex-nowrap">
                                    <li class="nav-item list-inline-item mr-0">
                                        <div class="dropdown">
                                            <a href="#" role="button" title="Details" data-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="false">
                                                <span data-feather="more-vertical"></span>
                                            </a>

                                            <div class="dropdown-menu dropdown-menu-right">
                                                <a class="dropdown-item align-items-center d-flex" href="#"
                                                    data-chat-info-toggle="">
                                                    <!-- Default :: Inline SVG -->
                                                    <span data-feather="users"></span>
                                                    <span>Create new group</span>
                                                </a>

                                                <a class="dropdown-item align-items-center d-flex" href="#">
                                                    <!-- Default :: Inline SVG -->
                                                    <span data-feather="trash-2"></span>

                                                    <span>Delete conversation</span>
                                                </a>
                                                <a class="dropdown-item align-items-center d-flex" href="#">
                                                    <!-- Default :: Inline SVG -->
                                                    <span data-feather="x-octagon"></span>

                                                    <span>Block & report</span>
                                                </a>
                                            </div>
                                        </div>
                                    </li>

                                </ul>
                            </div>
                            <div class="chat-box p-xl-30 pl-lg-20 pr-lg-0">
                                <div class="chat-loading-skeleton">
                                    <div class="skeleton-message" v-for="n in 3" :key="n" :class="n % 2 === 0 ? 'skeleton-incoming' : 'skeleton-outgoing'">
                                        <div class="skeleton-avatar" v-if="n % 2 === 0"></div>
                                        <div class="skeleton-bubble"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="currentChat" class="chat">
                        <div class="chat-body bg-white radius-xl shadow-sm">
                            <div class="chat-header" :class="{ 'hide-on-mobile': isMobile }">
                                <div class="media chat-name align-items-center">
                                    <div class="media-body align-self-center ">
                                        <h5 class="mb-0 fw-500 mb-2">{{ currentChat.name }}</h5>
                                        <div class="media-body__content d-flex align-items-center">
                                            <!-- <span class="badge-dot dot-success mr-1"></span> -->
                                            <small class="d-flex color-light fs-12 text-capitalize">
                                                {{ currentChat.number }}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                                <!-- Chat Options -->
                                <ul class="nav flex-nowrap">
                                    <li class="nav-item list-inline-item mr-0">
                                        <div class="dropdown">
                                            <a href="#" role="button" title="Details" data-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="false">
                                                <span data-feather="more-vertical"></span>
                                            </a>

                                            <div class="dropdown-menu dropdown-menu-right">
                                                <a class="dropdown-item align-items-center d-flex" href="#"
                                                    data-chat-info-toggle="">
                                                    <!-- Default :: Inline SVG -->
                                                    <span data-feather="users"></span>
                                                    <span>Create new group</span>
                                                </a>

                                                <a class="dropdown-item align-items-center d-flex" href="#">
                                                    <!-- Default :: Inline SVG -->
                                                    <span data-feather="trash-2"></span>

                                                    <span>Delete conversation</span>
                                                </a>
                                                <a class="dropdown-item align-items-center d-flex" href="#">
                                                    <!-- Default :: Inline SVG -->
                                                    <span data-feather="x-octagon"></span>

                                                    <span>Block & report</span>
                                                </a>
                                            </div>
                                        </div>
                                    </li>

                                </ul>
                            </div>
                            <div class="chat-box p-xl-30 pl-lg-20 pr-lg-0" :class="{ 'mobile-chat-box': isMobile }" ref="chatBox" @scroll="handleChatScroll">
                                <!-- Load more messages trigger (top) -->
                                <div v-if="hasMoreMessages && !isLoadingMoreMessages" class="load-more-messages-trigger" ref="messagesLoadMore">
                                    <button class="btn btn-sm btn-outline-primary" @click="loadMoreMessages">
                                        <i class="fas fa-chevron-up mr-1"></i>
                                        Load older messages
                                    </button>
                                </div>
                                <div v-if="isLoadingMoreMessages" class="loading-more-messages">
                                    <div class="loading-spinner-small"></div>
                                    <span>Loading older messages...</span>
                                </div>
                                
                                <!-- Empty state -->
                                <div v-if="chatMessages.length === 0" class="empty-chat-state">
                                    <div class="empty-chat-icon">
                                        <i class="fas fa-comments"></i>
                                    </div>
                                    <p class="empty-chat-text">No messages yet. Start the conversation!</p>
                                </div>
                                <!-- Start: Messages -->
                                <template v-for="(item, idx) in groupedChatMessages">
                                    <div v-if="item.type === 'date-separator'" 
                                        :key="'date-' + item.date + '-' + idx"
                                        class="date-separator">
                                        <span class="date-separator-line"></span>
                                        <span class="date-separator-text">{{ formatDateHeader(item.timestamp) }}</span>
                                        <span class="date-separator-line"></span>
                                    </div>
                                    
                                    <!-- Incoming Message -->
                                    <div v-else-if="item.type === 'message' && item.from_me == 0" 
                                        :key="'msg-incoming-' + item.created_at + '-' + item.jid + '-' + idx"
                                        class="flex-1 incoming-chat">
                                        <div class="chat-text-box">
                                            <div class="media">
                                                <div class="chat-text-box__photo">
                                                    <div class="avatar-initial-message">
                                                        {{ getInitials(currentChat.name) }}
                                                    </div>
                                                </div>
                                                <div class="media-body">
                                                    <div class="chat-text-box__content">
                                                        <div class="chat-text-box__title d-flex align-items-center">
                                                            <h6 class="fs-14">{{ currentChat.name }}</h6>
                                                            <span class="chat-text-box__time fs-12 color-light fw-400 ml-15">{{ formatTimeOnly(item.created_at) }}</span>
                                                        </div>
                                                        <div class="d-flex flex-column align-items-start mb-20 mt-10">
                                                            <!-- Image Bubble (+ Caption) -->
                                                            <div v-if="item.file && isImage(item.file)" 
                                                                class="chat-bubble incoming-bubble image-bubble"
                                                                @click="openModalImage(item.file)">
                                                                <img :src="item.file" class="chat-image" alt="Image">
                                                                <p v-if="item.text && item.text.trim() != ''" class="image-caption">{{ item.text }}</p>
                                                            </div>
                                                            <!-- Text/File Bubble (only if NOT an image) -->
                                                            <div v-if="!item.file || !isImage(item.file)" 
                                                                 class="chat-bubble incoming-bubble"
                                                                 :class="{ 'file-card-bubble': item.file }">
                                                                 <div v-if="item.file" class="file-preview-wrapper">
                                                                     <a :href="item.file" target="_blank" class="file-card">
                                                                         <div class="file-card-icon">
                                                                             <i :class="getFileIcon(item.file)"></i>
                                                                         </div>
                                                                         <div class="file-card-details">
                                                                             <div class="file-card-name">{{ getFileName(item.file) }}</div>
                                                                             <div class="file-card-size">{{ getFileExtension(item.file).toUpperCase() }} Document</div>
                                                                         </div>
                                                                         <div class="file-card-action">
                                                                             <i class="fas fa-download"></i>
                                                                         </div>
                                                                     </a>
                                                                 </div>
                                                                 <p v-if="item.text" class="message-text" :class="{ 'image-caption': item.file }">{{ item.text }}</p>
                                                             </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <!-- Outgoing Message -->
                                    <div v-else-if="item.type === 'message' && item.from_me == 1" 
                                        :key="'msg-outgoing-' + item.created_at + '-' + item.jid + '-' + idx"
                                        class="flex-1 justify-content-end d-flex outgoing-chat mt-20">
                                        <div class="chat-text-box">
                                            <div class="media">
                                                <div class="media-body">
                                                    <div class="chat-text-box__content">
                                                        <div class="chat-text-box__title d-flex align-items-center justify-content-end mb-2">
                                                            <span class="chat-text-box__time fs-12 color-light fw-400">{{ formatTimeOnly(item.created_at) }}</span>
                                                        </div>
                                                        <div class="d-flex flex-column align-items-end">
                                                            <!-- Image Bubble (+ Caption) -->
                                                            <div v-if="item.file && isImage(item.file)" 
                                                                class="chat-bubble outgoing-bubble image-bubble"
                                                                @click="openModalImage(item.file)">
                                                                <img :src="item.file" class="chat-image" alt="Image">
                                                                <p v-if="item.text && item.text.trim() != ''" class="image-caption">{{ item.text }}</p>
                                                            </div>
                                                            <!-- Text/File Bubble (only if NOT an image) -->
                                                            <div v-if="!item.file || !isImage(item.file)" 
                                                                class="chat-bubble outgoing-bubble"
                                                                :class="{ 'file-card-bubble': item.file }">
                                                                <div v-if="item.file" class="file-preview-wrapper">
                                                                    <a :href="item.file" target="_blank" class="file-card">
                                                                        <div class="file-card-icon">
                                                                            <i :class="getFileIcon(item.file)"></i>
                                                                        </div>
                                                                        <div class="file-card-details">
                                                                            <div class="file-card-name">{{ getFileName(item.file) }}</div>
                                                                            <div class="file-card-size">{{ getFileExtension(item.file).toUpperCase() }} Document</div>
                                                                        </div>
                                                                        <div class="file-card-action">
                                                                            <i class="fas fa-download"></i>
                                                                        </div>
                                                                    </a>
                                                                </div>
                                                                <p v-if="item.text" class="message-text" :class="{ 'image-caption': item.file }">{{ item.text }}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                            <div class="chat-footer">
                                <CustomText v-model.lazy="message" @updateFile="updateFile"></CustomText>
                            </div>
                        </div>
                    </div>
                    <div v-else class="chat">
                        <div class="chat-body bg-white radius-xl">
                            <div class="chat-header">
                                <div class="media chat-name align-items-center">
                                    <div class="media-body align-self-center ">
                                        <h5 class=" mb-0 fw-500 mb-2">Starsender Web Whatsapp</h5>
                                    </div>
                                </div>
                                <!-- Chat Options -->
                                <ul class="nav flex-nowrap">
                                    <li class="nav-item list-inline-item mr-0">
                                        <div class="dropdown">
                                            <a href="#" role="button" title="Details" data-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="false">
                                                <span data-feather="more-vertical"></span>
                                            </a>

                                            <div class="dropdown-menu dropdown-menu-right">
                                                <a class="dropdown-item align-items-center d-flex" href="#"
                                                    data-chat-info-toggle="">
                                                    <!-- Default :: Inline SVG -->
                                                    <span data-feather="users"></span>
                                                    <span>Create new group</span>
                                                </a>

                                                <a class="dropdown-item align-items-center d-flex" href="#">
                                                    <!-- Default :: Inline SVG -->
                                                    <span data-feather="trash-2"></span>

                                                    <span>Delete conversation</span>
                                                </a>
                                                <a class="dropdown-item align-items-center d-flex" href="#">
                                                    <!-- Default :: Inline SVG -->
                                                    <span data-feather="x-octagon"></span>

                                                    <span>Block & report</span>
                                                </a>
                                            </div>
                                        </div>
                                    </li>

                                </ul>
                            </div>
                            <div class="chat-box p-xl-30 pl-lg-20 pr-lg-0">
                                <div class="flex-1 incoming-chat">
                                    <div class="chat-text-box">
                                        <div class="media ">
                                            <div class="chat-text-box__photo">
                                                <div class="avatar-initial-message">
                                                    Admin
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <div class="chat-text-box__content">
                                                    <div class="chat-text-box__title d-flex align-items-center">
                                                        <h6 class="fs-14">Admin</h6>
                                                        <span
                                                            class="chat-text-box__time fs-12 color-light fw-400 ml-15">8:30
                                                            PM</span>
                                                    </div>
                                                    <div class="d-flex align-items-center mb-20 mt-10">
                                                        <div class="chat-text-box__subtitle p-20 bg-primary">
                                                            <p class="color-white">Sekarang, Anda dapat mengirim dan menerima pesan tanpa perlu menghubungkan telepon Anda ke Internet.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div><!-- Ends: .tab-content -->
        </div><!-- Ends: .chat-area -->
        
        <!-- Image Fullscreen Modal -->
        <transition name="fade">
            <div v-if="modalImageUrl" class="image-fullscreen-modal" @click="closeModalImage">
                <div class="modal-overlay"></div>
                <div class="modal-content-wrapper">
                    <img :src="modalImageUrl" class="modal-image-fullscreen" @click.stop>
                    <button class="modal-close-btn" @click="closeModalImage">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import moment from 'moment'
    import CustomText from "@/components/module/CustomText.vue";

    // Debounce utility function
    function debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

    export default {
        components: {
            CustomText,
        },
        data() {
            return {
                deviceID: 0,
                chatLists: [],
                contacts: [],
                isSelected: [],
                currentChat: null,
                chats: [],
                fn: {},
                message: "",
                isChatListLoading: true,
                isChatLoading: false,
                lastJID: null,
                file:null,
                searchQuery: "",
                debouncedSearch: null,
                dateCache: new Map(), // Cache for date formatting
                nameCache: new Map(), // Cache for contact names
                isSending: false,
                scrollTimeout: null,
                devices: [],
                selectedDeviceName: "Loading...",
                showDeviceDropdown: false,
                // Infinite scroll for chat list (cursor-based)
                chatListLimit: 20,
                chatListScrollObserver: null,
                isLoadingMoreChats: false,
                chatListHasMore: false,
                oldestChatListTimestamp: null,
                // Infinite scroll for messages (cursor-based)
                messagesLimit: 50,
                messagesScrollObserver: null,
                isLoadingMoreMessages: false,
                messagesHasMore: false,
                oldestMessageTimestamp: null,
                // Mobile layout
                isMobileSidebarOpen: false, // Will be set to true on mount if mobile
                modalImageUrl: null
            };
        },
        beforeDestroy() {
            this.$root.$off("ws", this.fn);
            if (this.scrollTimeout) {
                clearTimeout(this.scrollTimeout);
            }
            // Cleanup observers
            if (this.chatListScrollObserver) {
                this.chatListScrollObserver.disconnect();
            }
            if (this.messagesScrollObserver) {
                this.messagesScrollObserver.disconnect();
            }
            // Cleanup event listeners
            window.removeEventListener('resize', this.handleResize);
            document.removeEventListener('click', this.handleMobileSidebarClick);
        },
        watch: {
            '$store.state.history.chats': function () {
                // DOM not updated yet
                this.$nextTick(() => {
                    this.scrollToElement()
                });
            },
            searchQuery() {
                // Debounce search for better performance
                if (this.debouncedSearch) {
                    this.debouncedSearch();
                }
            },
            '$route'(to) {
                if (to.params.id && parseInt(to.params.id) != this.deviceID) {
                    this.deviceID = parseInt(to.params.id);
                    this.getDevices();
                    this.getContact();
                    this.getChatLists(true); // Reset chat lists
                    this.currentChat = null;
                    this.$store.commit("PUSH_HISTORY_CHATS", []);
                    // Open sidebar on mobile when switching devices
                    if (this.isMobile) {
                        this.isMobileSidebarOpen = true;
                    }
                }
            },
            currentChat(newVal) {
                // Auto-open sidebar on mobile when chat is closed
                if (this.isMobile && !newVal) {
                    this.isMobileSidebarOpen = true;
                }
            }
        },
        computed: {
            filteredChatLists() {
                const lists = this.$store.state.history.chat_lists || [];
                const query = (this.searchQuery || "").toLowerCase().trim();
                let filtered = lists;
                
                if (query) {
                    filtered = lists.filter((item) => {
                        const name = (this.getName(item.jid, item.number) || "").toLowerCase();
                        const number = String(item.number || "").toLowerCase();
                        const last = String(item.last_chat?.text || "").toLowerCase();
                        return (
                            name.includes(query) ||
                            number.includes(query) ||
                            last.includes(query)
                        );
                    });
                }
                
                return filtered;
            },
            hasMoreChatLists() {
                // If searching, don't show load more (all results are filtered client-side)
                if (this.searchQuery && this.searchQuery.trim()) {
                    return false;
                }
                return this.chatListHasMore && !this.isLoadingMoreChats;
            },
            chatMessages() {
                return this.$store.state.history.chats || [];
            },
            groupedChatMessages() {
                const messages = this.chatMessages;
                if (messages.length === 0) return [];
                
                const grouped = [];
                let currentDate = null;
                
                messages.forEach((message, index) => {
                    const messageDate = moment(message.created_at).format('YYYY-MM-DD');
                    const prevMessageDate = index > 0 ? moment(messages[index - 1].created_at).format('YYYY-MM-DD') : null;
                    
                    // Add date separator if this is a new date
                    if (messageDate !== prevMessageDate) {
                        grouped.push({
                            type: 'date-separator',
                            date: messageDate,
                            timestamp: message.created_at
                        });
                        currentDate = messageDate;
                    }
                    
                    // Add message with date info
                    grouped.push({
                        type: 'message',
                        ...message,
                        dateGroup: currentDate,
                        isFirstInGroup: messageDate !== prevMessageDate
                    });
                });
                
                return grouped;
            },
            hasMoreMessages() {
                return this.messagesHasMore && !this.isLoadingMoreMessages;
            },
            isMobile() {
                return window.innerWidth < 768;
            }
        },
        async mounted() {
            this.deviceID = parseInt(this.$route.params.id)
            await this.getDevices()
           
            // Initialize debounced search
            this.debouncedSearch = debounce(() => {
                // Force recompute
                this.$forceUpdate();
            }, 300);
            
            // Close dropdown when clicking outside
            document.addEventListener('click', this.handleClickOutside);
            
            // Handle window resize for mobile detection
            window.addEventListener('resize', this.handleResize);
            
            // Close mobile sidebar when clicking outside on mobile
            if (this.isMobile) {
                document.addEventListener('click', this.handleMobileSidebarClick);
                // Open sidebar by default on mobile if no chat is selected
                if (!this.currentChat) {
                    this.isMobileSidebarOpen = true;
                }
            }

            this.fn = (param) => {
                if(param == "pong") return
                try {
                    param = JSON.parse(param)
                    if (param.event == "incoming") {
                        if (param.data.message.device_id == this.deviceID) {
                            let newChat = {
                                jid: param.data.message.jid,
                                last_chat: {
                                    text: param.data.message.text,
                                    file: param.data.message.file,
                                    from_me: param.data.message.from_me
                                },
                                last_update: param.data.message.created_at,
                                number: param.data.message.number,
                                notification: 1
                            }

                            let chatLists = [...this.$store.state.history.chat_lists]
                            const existingIndex = chatLists.findIndex(item => item.jid === param.data.message.jid)

                            if (existingIndex !== -1) {
                                newChat.notification = (chatLists[existingIndex].notification || 0) + 1
                                chatLists.splice(existingIndex, 1)
                            }

                            if(param.data.message.jid == this.currentChat?.jid){
                                let chats = [...this.$store.state.history.chats]
                                chats.push(param.data.message)
                                this.$store.commit("PUSH_HISTORY_CHATS", chats)
                                newChat.notification = 0
                            }

                            chatLists = [newChat, ...chatLists]
                            this.$store.commit("PUSH_CHAT_LIST", chatLists)
                        }
                    }
                } catch (err) {
                    console.error("Error parsing WS message:", err);
                }
            }
            this.$root.$on("ws", this.fn);

            // Load data in parallel for better performance
            await Promise.all([
                this.getContact(),
                this.getChatLists(true) // Reset on initial load
            ])
        },
        methods: {
            async getDevices() {
                try {
                    let res = await this.$store.dispatch("device_list_all", { status: "all" });
                    this.devices = res.data.data.devices || [];
                    
                    // Set selected device name
                    const currentDevice = this.devices.find(d => d.id == this.deviceID);
                    if (currentDevice) {
                        this.selectedDeviceName = currentDevice.name;
                    } else {
                        this.selectedDeviceName = "Device " + this.deviceID;
                    }
                } catch (err) {
                    console.error("Error loading devices:", err);
                    this.selectedDeviceName = "Device " + this.deviceID;
                }
            },
            toggleDeviceDropdown() {
                this.showDeviceDropdown = !this.showDeviceDropdown;
            },
            handleClickOutside(event) {
                const dropdown = this.$el.querySelector('.device-selector-header');
                if (dropdown && !dropdown.contains(event.target)) {
                    this.showDeviceDropdown = false;
                }
            },
            switchDevice(deviceId) {
                if (deviceId == this.deviceID) {
                    this.showDeviceDropdown = false;
                    return;
                }
                this.showDeviceDropdown = false;
                this.$router.push(`/web-whatsapp/${deviceId}`);
            },
            formatDateRelative(unix) {
                // Cache date formatting for better performance
                const cacheKey = `relative_${unix}`;
                if (this.dateCache.has(cacheKey)) {
                    return this.dateCache.get(cacheKey);
                }
                const formatted = moment(unix).fromNow();
                this.dateCache.set(cacheKey, formatted);
                // Clear cache after 1 minute to update "just now" etc
                setTimeout(() => this.dateCache.delete(cacheKey), 60000);
                return formatted;
            },
            formatDateDetail(unix) {
                // Cache date formatting for better performance
                const cacheKey = `detail_${unix}`;
                if (this.dateCache.has(cacheKey)) {
                    return this.dateCache.get(cacheKey);
                }
                const formatted = moment(unix).format("LLL");
                this.dateCache.set(cacheKey, formatted);
                return formatted;
            },
            formatTimeOnly(unix) {
                // Format time only (HH:mm)
                const cacheKey = `time_${unix}`;
                if (this.dateCache.has(cacheKey)) {
                    return this.dateCache.get(cacheKey);
                }
                const formatted = moment(unix).format("HH:mm");
                this.dateCache.set(cacheKey, formatted);
                return formatted;
            },
            formatDateHeader(unix) {
                // Format date header (e.g., "Today", "Yesterday", or date)
                const today = moment().startOf('day');
                const messageDate = moment(unix).startOf('day');
                const diffDays = today.diff(messageDate, 'days');
                
                if (diffDays === 0) {
                    return 'Today';
                } else if (diffDays === 1) {
                    return 'Yesterday';
                } else if (diffDays < 7) {
                    return moment(unix).format('dddd'); // Day name
                } else {
                    return moment(unix).format('MMMM D, YYYY'); // Full date
                }
            },
            async getContact(){
                try{
                    let res = await this.$store.dispatch("contact_load_from_device", {
                        id: parseInt(this.deviceID)
                    });

                    let contacts = res.data.data.contacts
                    for (let i = 0; i < contacts.length; i++) {
                        contacts[i].number = this.formatNumber(contacts[i].number, contacts[i].is_group)
                    }

                    this.$store.commit("PUSH_HISTORY_CONTACTS", contacts)
                }catch(err){
                    console.log(err)
                }

            },
            getName(jid, number){
                // Cache name lookups for better performance
                if (this.nameCache.has(jid)) {
                    return this.nameCache.get(jid);
                }
                
                let contact = this.$store.state.history.contacts.find(el => el.number == jid)
                const name = contact?.name || number;
                this.nameCache.set(jid, name);
                return name;
            },
            async getChatLists(reset = false) {
                if (reset) {
                    this.oldestChatListTimestamp = null;
                    this.chatListHasMore = false;
                    this.$store.commit("PUSH_CHAT_LIST", []);
                }
                
                let res = await this.$store.dispatch("history_chat_lists", {
                    id: parseInt(this.deviceID),
                    limit: this.chatListLimit,
                    before_timestamp: reset ? null : this.oldestChatListTimestamp
                });
                
                const newLists = res.data.data.chat_lists || [];
                const existingLists = this.$store.state.history.chat_lists || [];
                
                if (reset) {
                    this.$store.commit("PUSH_CHAT_LIST", newLists);
                } else {
                    // Append new lists to existing ones
                    this.$store.commit("PUSH_CHAT_LIST", [...existingLists, ...newLists]);
                }
                
                // Update cursor and has_more flag
                this.chatListHasMore = res.data.data.has_more || false;
                if (newLists.length > 0) {
                    // Find oldest timestamp from new lists
                    const oldest = Math.min(...newLists.map(list => list.last_update || 0));
                    if (oldest > 0) {
                        this.oldestChatListTimestamp = oldest;
                    }
                }
                
                this.isChatListLoading = false
                
                // Setup infinite scroll after chat lists load
                this.$nextTick(() => {
                    this.setupChatListInfiniteScroll();
                });
            },
            async getChats(jid, beforeTimestamp = null) {
                let res = await this.$store.dispatch("history_chats", {
                    id: parseInt(this.deviceID),
                    jid: jid,
                    limit: this.messagesLimit,
                    before_timestamp: beforeTimestamp
                });

                const chats = res.data.data.chats || [];
                this.messagesHasMore = res.data.data.has_more || false;
                
                // Track oldest message timestamp for pagination
                if (chats.length > 0) {
                    this.oldestMessageTimestamp = chats[0].created_at;
                }
                
                return chats;
            },
			updateFile(e) {
				this.file=e;
			},
            async sendMessage(){
                if((this.message.trim() === "" && this.file === null) || this.isSending){
                    return
                }
                
                this.isSending = true
                const text = this.message.trim()
                let number = this.currentChat.number
                // Extract number from JID format if needed (remove @s.whatsapp.net or @g.us)
                if(number && number.includes('@')){
                    number = number.split('@')[0]
                }
                
                let url = null
                let fileToUpload = this.file
                
                try {
                    if(fileToUpload){
                        let formData = new FormData();
                        formData.append('file', fileToUpload)
                        let response = await this.$store.dispatch('cdn_upload', formData)
                        url = response.data.data.url
                    }
                    
                    // Clear input immediately for better UX
                    this.message = ""
                    this.file = null
                    
                    let broadcastItem = {
                        message_type: "text",
                        to: number,
                        text: text || "",
                        delay: 0,
                    }
                    
                    // Only include file field if there's actually a URL
                    if(url && url.trim() !== ""){
                        broadcastItem.file = url
                    }
                    
                    let finalMessage = {
                        device_id: parseInt(this.deviceID),
                        schedule: moment().utc().valueOf(),
                        broadcast: [broadcastItem]
                    }

                    // Optimistically update UI
                    const optimisticChat = {
                        device_id: parseInt(this.deviceID),
                        from_me: 1,
                        jid: this.currentChat.jid,
                        number: number,
                        text: text,
                        file: url,
                        created_at: finalMessage.schedule,
                        updated_at: finalMessage.schedule
                    }

                    let chats = [...this.$store.state.history.chats]
                    chats.push(optimisticChat)
                    this.$store.commit("PUSH_HISTORY_CHATS", chats)

                    let chatLists = [...this.$store.state.history.chat_lists]
                    let lastChatIndex = chatLists.findIndex(a => a.jid === this.currentChat.jid)
                    if (lastChatIndex !== -1) {
                        chatLists[lastChatIndex] = {
                            ...chatLists[lastChatIndex],
                            last_chat: { ...chatLists[lastChatIndex].last_chat, text: text },
                            last_update: finalMessage.schedule
                        }
                    }
                    this.$store.commit("PUSH_CHAT_LIST", chatLists)

                    // Send to backend
                    await this.$store.dispatch('outgoing_send', finalMessage)
                    
                } catch(err){
                    // Revert optimistic update on error
                    this.message = text
                    this.file = fileToUpload
                    this.$toast.error(err.response?.data?.message || "Error sending message")
                } finally {
                    this.isSending = false
                }
            },
            formatNumber(number, is_group){
                if(number.charAt(0) == "0"){
                    number = "62" + number.substring(1)
                }

                if(is_group){
                    number = number + "@g.us"
                }else{
                    number = number + "@s.whatsapp.net"
                }

                return number
            },
            async openChat(jid){
                if(this.currentChat?.jid == jid) return
                this.select(jid)
                // Close mobile sidebar when opening chat
                if (this.isMobile) {
                    this.isMobileSidebarOpen = false;
                }
                this.openChatProcess(jid)
            },
            async openChatProcess(jid){
                this.isChatLoading = true

                this.currentChat = {}
                this.currentChat = this.$store.state.history.chat_lists.find(a => a.jid == jid)

                this.currentChat.name = this.getName(this.currentChat.jid, this.currentChat.number)
                
                // Reset messages state
                this.messagesHasMore = false;
                this.oldestMessageTimestamp = null;
                this.$store.commit("PUSH_HISTORY_CHATS", await this.getChats(jid))
                //this.chats = chats

                let modifiedChat = this.currentChat
                modifiedChat.notification = 0
                let chatLists = this.$store.state.history.chat_lists.map(u => u.jid !== jid ? u : modifiedChat)
                this.$store.commit("PUSH_CHAT_LIST", chatLists)
                this.isChatLoading = false
                
                // Setup infinite scroll for messages
                this.$nextTick(() => {
                    this.setupMessagesInfiniteScroll();
                    
                    // Scroll to bottom instantly after chat loads
                    const container = this.$refs.chatBox;
                    if (container) {
                        container.scrollTop = container.scrollHeight;
                    }
                });
            },
            select(id) {
                // Selection is now handled by CSS class binding, no need for manual DOM manipulation
                this.lastJID = id
            },
            isImage(fileUrl) {
                if (!fileUrl) return false;
                const extensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'];
                const parts = fileUrl.split('.');
                if (parts.length < 2) return false;
                const ext = parts.pop().toLowerCase().split('?')[0];
                return extensions.includes(ext);
            },
            isVideo(fileUrl) {
                if (!fileUrl) return false;
                const extensions = ['mp4', 'webm', 'ogg', 'mov', 'avi'];
                const parts = fileUrl.split('.');
                if (parts.length < 2) return false;
                const ext = parts.pop().toLowerCase().split('?')[0];
                return extensions.includes(ext);
            },
            isPdf(fileUrl) {
                if (!fileUrl) return false;
                const parts = fileUrl.split('.');
                if (parts.length < 2) return false;
                const ext = parts.pop().toLowerCase().split('?')[0];
                return ext === 'pdf';
            },
            getFileExtension(fileUrl) {
                if (!fileUrl) return '';
                const parts = fileUrl.split('.');
                if (parts.length < 2) return 'file';
                return parts.pop().toLowerCase().split('?')[0];
            },
            getFileIcon(fileUrl) {
                const ext = this.getFileExtension(fileUrl);
                switch(ext) {
                    case 'pdf': return 'fas fa-file-pdf text-danger';
                    case 'doc':
                    case 'docx': return 'fas fa-file-word text-primary';
                    case 'xls':
                    case 'xlsx': return 'fas fa-file-excel text-success';
                    case 'ppt':
                    case 'pptx': return 'fas fa-file-powerpoint text-warning';
                    case 'zip':
                    case 'rar':
                    case '7z': return 'fas fa-file-archive text-muted';
                    case 'mp4':
                    case 'webm':
                    case 'avi':
                    case 'mov': return 'fas fa-file-video text-info';
                    case 'mp3':
                    case 'wav':
                    case 'ogg': return 'fas fa-file-audio text-info';
                    default: return 'fas fa-file-alt text-muted';
                }
            },
            getFileName(fileUrl) {
                if (!fileUrl) return '';
                const fileName = fileUrl.substring(fileUrl.lastIndexOf('/') + 1);
                return fileName.length > 30 ? fileName.substring(0, 30) + '...' : fileName;
            },
            trimString (string, length) {
                if(string == null || string == ""){
                    return ""
                }
                return string.length > length ? string.substring(0, length) + '...' : string;            
            },
            getInitials(name) {
                if (!name || name.trim() === '') return '?';
                
                // Remove special characters and extra spaces
                const cleanName = name.trim().replace(/[^a-zA-Z0-9\s]/g, '');
                const parts = cleanName.split(/\s+/).filter(p => p.length > 0);
                
                if (parts.length === 0) {
                    // If no valid parts, try to get first character
                    const firstChar = name.trim().charAt(0).toUpperCase();
                    return firstChar || '?';
                }
                
                if (parts.length === 1) {
                    // Single word: take first 2 characters
                    return parts[0].substring(0, 2).toUpperCase();
                }
                
                // Multiple words: take first character of first and last word
                return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
            },
            scrollToElement() {
                if (this.scrollTimeout) {
                    clearTimeout(this.scrollTimeout);
                }
                this.scrollTimeout = setTimeout(() => {
                    const container = this.$refs.chatBox;
                    if (container) {
                        container.scrollTop = container.scrollHeight;
                    }
                }, 50);
            },
            setupChatListInfiniteScroll() {
                if (!this.$refs.chatListLoadMore) return;
                
                // Cleanup existing observer
                if (this.chatListScrollObserver) {
                    this.chatListScrollObserver.disconnect();
                }
                
                // Create intersection observer for chat list
                const container = this.$refs.chatListContainer?.parentElement;
                this.chatListScrollObserver = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting && this.hasMoreChatLists && !this.isLoadingMoreChats) {
                            this.loadMoreChatLists();
                        }
                    });
                }, {
                    root: container,
                    rootMargin: '100px',
                    threshold: 0.1
                });
                
                if (this.$refs.chatListLoadMore) {
                    this.chatListScrollObserver.observe(this.$refs.chatListLoadMore);
                }
            },
            async loadMoreChatLists() {
                if (this.isLoadingMoreChats || !this.hasMoreChatLists) return;
                
                this.isLoadingMoreChats = true;
                
                try {
                    await this.getChatLists(false); // Don't reset, append using cursor
                } catch (err) {
                    console.error("Error loading more chat lists:", err);
                } finally {
                    this.isLoadingMoreChats = false;
                }
            },
            setupMessagesInfiniteScroll() {
                if (!this.$refs.messagesLoadMore) return;
                
                // Cleanup existing observer
                if (this.messagesScrollObserver) {
                    this.messagesScrollObserver.disconnect();
                }
                
                // Create intersection observer for messages (load older messages when scrolling to top)
                this.messagesScrollObserver = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting && this.hasMoreMessages && !this.isLoadingMoreMessages) {
                            this.loadMoreMessages();
                        }
                    });
                }, {
                    root: this.$refs.chatBox,
                    rootMargin: '50px',
                    threshold: 0.1
                });
                
                if (this.$refs.messagesLoadMore) {
                    this.messagesScrollObserver.observe(this.$refs.messagesLoadMore);
                }
            },
            async loadMoreMessages() {
                if (this.isLoadingMoreMessages || !this.hasMoreMessages || !this.currentChat) return;
                
                const container = this.$refs.chatBox;
                const oldScrollHeight = container ? container.scrollHeight : 0;
                const oldScrollTop = container ? container.scrollTop : 0;
                
                this.isLoadingMoreMessages = true;
                
                try {
                    // Get older messages using cursor-based pagination
                    const olderMessages = await this.getChats(this.currentChat.jid, this.oldestMessageTimestamp);
                    
                    if (olderMessages && olderMessages.length > 0) {
                        // Prepend older messages to existing chats
                        const existingChats = this.$store.state.history.chats || [];
                        this.$store.commit("PUSH_HISTORY_CHATS", [...olderMessages, ...existingChats]);
                    }
                } catch (err) {
                    console.error("Error loading more messages:", err);
                } finally {
                    this.isLoadingMoreMessages = false;
                    
                    this.$nextTick(() => {
                        // Maintain scroll position (prevent jump)
                        if (container) {
                            const newScrollHeight = container.scrollHeight;
                            container.scrollTop = oldScrollTop + (newScrollHeight - oldScrollHeight);
                        }
                        
                        this.setupMessagesInfiniteScroll();
                    });
                }
            },
            handleChatScroll(event) {
                const container = event.target;
                // Auto-load more when near top (within 200px)
                if (container.scrollTop < 200 && this.hasMoreMessages && !this.isLoadingMoreMessages) {
                    this.loadMoreMessages();
                }
            },
            toggleMobileSidebar() {
                this.isMobileSidebarOpen = !this.isMobileSidebarOpen;
            },
            closeMobileChat() {
                // Close chat first (this removes mobile-chat-open class)
                this.currentChat = null;
                this.$store.commit("PUSH_HISTORY_CHATS", []);
                // Open sidebar (chat list) on mobile after chat is closed
                if (this.isMobile) {
                    // Set immediately
                    this.isMobileSidebarOpen = true;
                    // Wait for Vue to update DOM and remove mobile-chat-open class
                    this.$nextTick(() => {
                        // Force sidebar open after DOM update
                        this.isMobileSidebarOpen = true;
                        // Use requestAnimationFrame to ensure CSS is applied
                        requestAnimationFrame(() => {
                            if (!this.currentChat && this.isMobile) {
                                this.isMobileSidebarOpen = true;
                            }
                        });
                    });
                }
            },
            handleResize() {
                // Auto-close sidebar on mobile when window is resized to desktop
                if (!this.isMobile && this.isMobileSidebarOpen) {
                    this.isMobileSidebarOpen = false;
                } else if (this.isMobile && !this.currentChat) {
                    // Open sidebar if on mobile and no chat selected
                    this.isMobileSidebarOpen = true;
                }
            },
            handleMobileSidebarClick(event) {
                if (!this.isMobile) return;
                
                const sidebar = this.$el.querySelector('.chat-sidebar');
                const toggleBtn = this.$el.querySelector('.mobile-menu-btn, .mobile-sidebar-toggle');
                
                // Close sidebar if clicking outside
                if (this.isMobileSidebarOpen && 
                    sidebar && 
                    !sidebar.contains(event.target) &&
                    (!toggleBtn || !toggleBtn.contains(event.target))) {
                    this.isMobileSidebarOpen = false;
                }
            },
            openModalImage(url) {
                this.modalImageUrl = url;
            },
            closeModalImage() {
                this.modalImageUrl = null;
            }
        },
    };
</script>

<style scoped>
    /* Full Screen Chat */
    .chat-fullscreen {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100vw;
        height: 100vh;
        overflow: hidden;
        background: #f1f3f8;
        z-index: 9999;
        margin: 0;
        padding: 12px;
        box-sizing: border-box;
    }
    
    /* Ensure no padding/margin from parent */
    #app {
        height: 100vh;
        overflow: hidden;
    }
    
    #app > div:has(.chat-fullscreen) {
        height: 100vh;
        overflow: hidden;
    }
    
    .chat-area-fullscreen {
        display: flex;
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        gap: 12px;
    }
    
    /* Mobile: Full width chat container */
    @media (max-width: 767px) {
        .chat-fullscreen {
            padding: 0 !important;
            background: white;
        }
        
        .chat-area-fullscreen.mobile-chat-open {
            background: white;
            width: 100vw !important;
            gap: 0;
        }
        
        .chat-area-fullscreen.mobile-chat-open .tab-content {
            width: 100vw !important;
        }
        
        .chat-area-fullscreen.mobile-chat-open .chat {
            width: 100vw !important;
        }
        
        .chat-area-fullscreen.mobile-chat-open .chat-body {
            width: 100vw !important;
            max-width: 100vw !important;
        }
    }
    
    .chat-area-fullscreen .chat-sidebar {
        margin: 0 !important;
        margin-bottom: 0 !important;
        height: 100%;
        overflow: hidden;
        flex-shrink: 0;
        border-radius: 12px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
    
    .chat-area-fullscreen .sidebar-group {
        margin: 0;
        height: 100%;
    }
    
    .chat-area-fullscreen .left-sidebar-wrap {
        height: 100%;
        border-radius: 12px;
        display: flex;
        flex-direction: column;
        margin: 0;
        overflow: hidden;
    }
    
    .chat-area-fullscreen .chat-wrapper {
        height: 100%;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }
    
    .chat-area-fullscreen .search-header {
        flex-shrink: 0;
    }
    
    .chat-area-fullscreen .search-body {
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;
        min-height: 0;
        height: 0; /* Force flexbox to calculate height correctly */
    }
    
    .chat-area-fullscreen .sidebar-footer {
        flex-shrink: 0;
        padding: 16px;
        border-top: 1px solid #e5e7eb;
        background: white;
    }
    
    .sidebar-back-btn {
        width: 100%;
        padding: 0.75rem 1rem;
        font-size: 0.875rem;
        font-weight: 500;
        border-radius: 8px;
        transition: all 0.2s;
        text-decoration: none;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #d1d5db;
        color: #374151;
        background: white;
    }
    
    .sidebar-back-btn:hover {
        background: #f9fafb;
        border-color: #9ca3af;
        color: #111827;
        text-decoration: none;
    }
    
    .sidebar-back-btn:focus {
        box-shadow: 0 0 0 3px rgba(156, 163, 175, 0.1);
        outline: none;
    }
    
    .sidebar-back-btn i {
        font-size: 0.875rem;
    }
    
    .chat-area-fullscreen .search-body::-webkit-scrollbar {
        width: 6px;
    }
    
    .chat-area-fullscreen .search-body::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
    }
    
    .chat-area-fullscreen .search-body::-webkit-scrollbar-thumb {
        background: #cbd5e1;
        border-radius: 10px;
    }
    
    .chat-area-fullscreen .search-body::-webkit-scrollbar-thumb:hover {
        background: #94a3b8;
    }
    
    .chat-area-fullscreen .tab-content {
        height: 100%;
        display: flex;
        flex-direction: column;
        width: 100%;
        flex: 1;
        min-height: 0;
    }
    
    .chat-area-fullscreen .tab-pane {
        height: 100%;
        display: flex;
        flex-direction: column;
        min-height: 0;
    }
    
    .chat-area-fullscreen .chat {
        height: 100%;
        display: flex;
        flex-direction: column;
        min-height: 0;
    }
    
    .chat-area-fullscreen .chat-body {
        height: 100%;
        display: flex;
        flex-direction: column;
        border-radius: 12px;
        margin: 0;
        flex: 1;
        min-height: 0;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        overflow: hidden;
    }
    
    /* Mobile: Remove border-radius when header is hidden */
    @media (max-width: 767px) {
        .chat-area-fullscreen.mobile-chat-open .chat-body {
            border-radius: 0;
        }
    }
    
    .chat-area-fullscreen .chat-header {
        flex-shrink: 0;
    }
    
    .chat-area-fullscreen .chat-box {
        flex: 1;
        overflow-y: auto;
        max-height: none;
        min-height: 0;
    }
    
    .chat-area-fullscreen .chat-footer {
        flex-shrink: 0;
        margin: 0;
    }
    
    /* Override any global styles that might interfere */
    .chat-fullscreen .contents {
        margin: 0;
        padding: 0;
    }
    
    .chat-fullscreen .container-fluid {
        margin: 0;
        padding: 0;
        height: 100%;
    }
    
    /* Modern Chat List Styles */
    .chatactive {
        background: #eef2ff !important;
        color: #111827;
        transform: translateX(4px);
        box-shadow: 0 4px 12px rgba(79, 70, 229, 0.15);
    }
    .chatactive .chat-name,
    .chatactive .last-message,
    .chatactive .chat-time {
        color: #111827 !important;
    }
    .chatactive .online-indicator {
        border-color: #eef2ff;
        box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
    }
    
    .user-list {
        list-style: none;
        padding: 8px;
        margin: 0;
    }
    
    .user-list-item {
        border-radius: 16px;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        padding: 12px;
        margin: 4px 0;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    
    .user-list-item::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 3px;
        background: #4f46e5;
        transform: scaleY(0);
        transition: transform 0.3s ease;
    }
    
    .chatactive::before {
        transform: scaleY(1);
    }
    
    .user-list-item:hover {
        background: #f3f4f6;
        transform: translateX(2px);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    }
    
    .user-list-item__wrapper {
        padding: 0 0px !important;
        display: flex;
        align-items: center;
        gap: 12px;
    }
    
    .avatar-wrapper {
        position: relative;
        flex-shrink: 0;
    }
    
    .avatar-circle {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        overflow: hidden;
        position: relative;
        border: 3px solid #e5e7eb;
        transition: all 0.3s ease;
    }
    
    .user-list-item:hover .avatar-circle {
        border-color: #667eea;
        transform: scale(1.05);
    }
    
    .avatar-initial {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #667eea;
        color: white;
        font-weight: 600;
        font-size: 0.875rem;
        letter-spacing: 0.5px;
    }
        .avatar-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    
    .online-indicator {
        position: absolute;
        bottom: 2px;
        right: 2px;
        width: 14px;
        height: 14px;
        background: #10b981;
        border: 2px solid white;
        border-radius: 50%;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }
    
    .users-list-body {
        flex: 1;
        min-width: 0;
    }
    
    .name-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 4px;
    }
    
    .chat-name {
        font-weight: 600;
        font-size: 15px;
        color: #1f2937;
        margin: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 1;
    }
    
    .chat-time {
        font-size: 12px;
        color: #9ca3af;
        font-weight: 500;
        white-space: nowrap;
        margin-left: 8px;
    }
    
    .message-preview {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 8px;
    }
    
    .last-message {
        margin: 0;
        color: #6b7280;
        font-size: 13px;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 1;
    }
    
    .message-icon {
        margin-right: 4px;
        opacity: 0.7;
    }
    
    .notification-badge {
        background: #ef4444;
        color: white;
        font-size: 11px;
        font-weight: 600;
        padding: 2px 8px;
        border-radius: 12px;
        min-width: 20px;
        text-align: center;
        box-shadow: 0 2px 4px rgba(239, 68, 68, 0.3);
        flex-shrink: 0;
    }
    
    /* Modern Search Bar */
    .search-header {
        padding: 16px;
        background: white;
        border-bottom: 1px solid #e5e7eb;
    }
    
    .search-input-wrapper {
        position: relative;
        display: flex;
        align-items: center;
    }
    
    .search-icon {
        position: absolute;
        left: 16px;
        color: #9ca3af;
        font-size: 16px;
        z-index: 1;
    }
    
    .search-input {
        width: 100%;
        padding: 12px 16px 12px 44px;
        border: 2px solid #e5e7eb;
        border-radius: 12px;
        font-size: 14px;
        transition: all 0.3s ease;
        background: #f9fafb;
    }
    
    .search-input:focus {
        outline: none;
        border-color: #667eea;
        background: white;
        box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
    }
    
    .search-clear {
        position: absolute;
        right: 12px;
        color: #9ca3af;
        cursor: pointer;
        padding: 4px;
        border-radius: 50%;
        transition: all 0.2s ease;
    }
    
    .search-clear:hover {
        background: #e5e7eb;
        color: #374151;
    }
    
    /* Loading Skeletons */
    .chat-list-loading {
        padding: 10px;
    }
    .skeleton-item {
        display: flex;
        padding: 10px;
        margin-bottom: 8px;
        animation: skeleton-loading 1.5s ease-in-out infinite;
    }
    .skeleton-avatar {
        width: 46px;
        height: 46px;
        border-radius: 50%;
        background: #f0f0f0;
        margin-right: 12px;
        flex-shrink: 0;
    }
    .skeleton-content {
        flex: 1;
    }
    .skeleton-line {
        height: 12px;
        border-radius: 4px;
        background: #f0f0f0;
        margin-bottom: 8px;
    }
    .skeleton-title {
        width: 60%;
        margin-bottom: 6px;
    }
    .skeleton-text {
        width: 80%;
    }
    @keyframes skeleton-loading {
        0% { background-position: 200% 0; }
        100% { background-position: -200% 0; }
    }
    
    /* Chat Loading Skeleton */
    .chat-loading-skeleton {
        padding: 20px;
    }
    .skeleton-message {
        display: flex;
        margin-bottom: 20px;
        align-items: flex-end;
    }
    .skeleton-message.skeleton-incoming {
        justify-content: flex-start;
    }
    .skeleton-message.skeleton-outgoing {
        justify-content: flex-end;
    }
    .skeleton-bubble {
        height: 40px;
        width: 200px;
        border-radius: 18px;
        background: #f0f0f0;
        animation: skeleton-loading 1.5s ease-in-out infinite;
    }
    
    /* Enhanced Empty State */
    .empty-chat-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        min-height: 400px;
        padding: 40px;
        text-align: center;
    }
    .empty-chat-icon {
        font-size: 80px;
        margin-bottom: 24px;
        color: #9ca3af;
        opacity: 0.7;
        animation: float 3s ease-in-out infinite;
    }
    
    @keyframes float {
        0%, 100% { transform: translateY(0px); }
        50% { transform: translateY(-10px); }
    }
    
    .empty-chat-text {
        font-size: 18px;
        color: #6b7280;
        margin: 0;
        font-weight: 500;
    }
    
    
    /* Enhanced Chat Box */
    .chat-box {
        scroll-behavior: auto;
        overflow-y: auto;
        padding: 24px;
        background: #f9fafb;
        flex: 1;
        min-height: 0;
    }
    
    .chat-box::-webkit-scrollbar {
        width: 6px;
    }
    
    .chat-box::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
    }
    
    .chat-box::-webkit-scrollbar-thumb {
        background: #cbd5e1;
        border-radius: 10px;
    }
    
    .chat-box::-webkit-scrollbar-thumb:hover {
        background: #94a3b8;
    }
    
    /* Modern Chat Bubbles */
    .chat-bubble {
        max-width: min(420px, 72vw); /* 🔑 */
        min-width: 50px;
        width: fit-content;

        padding: 10px 14px;
        border-radius: 18px;
        position: relative;

        animation: messageSlideIn 0.3s ease-out;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);

        flex-shrink: 0; /* penting kalau parent flex */
    }

    
    @keyframes messageSlideIn {
        from {
            opacity: 0;
            transform: translateY(10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
    
    .incoming-bubble {
        background: #ffffff;
        color: #1f2937;
        border-bottom-left-radius: 4px;
        margin-right: auto;
        border: 1px solid #e5e7eb;
    }
    
    .incoming-bubble .message-text {
        color: #1f2937;
        margin: 0;
        line-height: 1.5;
    }
    
    .outgoing-bubble {
        background: #dcf8c6;
        color: #1f2937;
        border-bottom-right-radius: 4px;
        margin-left: auto;
        border: 1px solid #ccedaa;
    }
    
    .outgoing-bubble .message-text {
        color: #1f2937;
        margin: 0;
        line-height: 1.5;
    }
    
    .message-text {
        font-size: 14.5px;
        line-height: 1.6;
        white-space: pre-wrap;
        overflow-wrap: break-word;
        word-break: normal;
    }

    
    .file-preview {
        margin-top: 8px;
        padding-top: 8px;
        border-top: 1px solid rgba(0, 0, 0, 0.08);
    }
    
    .file-link {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 8px 12px;
        background: rgba(255, 255, 255, 0.3);
        border-radius: 8px;
        text-decoration: none;
        color: inherit;
        transition: all 0.2s ease;
        font-size: 13px;
    }
    
    .outgoing-bubble .file-link {
        background: rgba(0, 0, 0, 0.05);
        color: #374151;
    }
    
    .file-link:hover {
        background: rgba(0, 0, 0, 0.08);
        transform: translateY(-1px);
    }
    
    /* Chat Header Enhancement */
    .chat-header {
        background: #4f46e5;
        color: white;
        padding: 16px 24px;
        border-radius: 12px 12px 0 0;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
    
    .chat-header h5 {
        color: white;
        font-weight: 600;
    }
    
    .chat-header small {
        color: rgba(255, 255, 255, 0.9);
    }
    
    /* Enhanced Responsive Design */
    @media (max-width: 768px) {
        .chat-box {
            padding: 16px;
        }
        .chat-bubble {
            max-width: 85%;
        }
        .user-list-item {
            padding: 10px;
        }
        .avatar-circle {
            width: 48px;
            height: 48px;
        }
        .search-header {
            padding: 12px;
        }
    }
    
    /* Additional Enhancements */
    .chat-body {
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    }
    
    .chat-footer {
        background: white;
        border-top: 1px solid #e5e7eb;
        padding: 8px 12px !important;
        flex-shrink: 0;
    }
    
    /* Compact CustomText styling */
    ::v-deep .chat-footer > .w-100 {
        margin: 0;
    }
    
    ::v-deep .chat-footer label {
        font-size: 0.75rem;
        margin-bottom: 4px;
        padding: 0 8px;
        color: #6b7280;
    }
    
    ::v-deep .chat-footer .d-flex.flex-wrap {
        align-items: center;
        gap: 4px;
        margin: 0;
    }
    
    ::v-deep .chat-footer .chat-type-text__write {
        background: #f9fafb;
        border-radius: 20px;
        padding: 6px 12px;
        border: 1px solid #e5e7eb;
        flex: 1;
        min-width: 0;
    }
    
    ::v-deep .chat-footer .chat-type-text__write input {
        font-size: 0.875rem;
        padding: 0;
        margin: 0;
        border: none;
        background: transparent;
        flex: 1;
    }
    
    ::v-deep .chat-footer #plus {
        padding: 4px 8px;
        margin: 0;
        color: #6b7280;
        font-size: 0.875rem;
        min-width: 32px;
    }
    
    ::v-deep .chat-footer #plus:hover {
        color: #4f46e5;
    }
    
    ::v-deep .chat-footer .emoji-invoker {
        padding: 4px;
        margin: 0;
        min-width: 32px;
    }
    
    ::v-deep .chat-footer .emoji-invoker svg {
        width: 18px;
        height: 18px;
    }
    
    ::v-deep .chat-footer button.btn-primary {
        padding: 8px 12px;
        min-width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-left: 4px;
    }
    
    ::v-deep .chat-footer button.btn-primary .fa-paper-plane {
        font-size: 0.875rem;
    }
    
    .incoming-chat,
    .outgoing-chat {
        margin-bottom: 16px;
        display: flex;
        align-items: flex-end;
    }
    
    .incoming-chat {
        justify-content: flex-start;
    }
    
    .outgoing-chat {
        justify-content: flex-end;
    }
    
    .chat-text-box__photo {
        margin-right: 12px;
        align-self: flex-end;
        margin-bottom: 16px !important;
        flex-shrink: 0;
    }
    
    .chat-text-box__photo img {
        border-radius: 50%;
        border: 2px solid #e5e7eb;
    }
    
    .avatar-initial-message {
        width: 46px;
        height: 46px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #667eea;
        color: white;
        font-weight: 600;
        font-size: 0.75rem;
        letter-spacing: 0.5px;
        border: 2px solid #e5e7eb;
    }
    
    .outgoing-chat .avatar-initial-message {
        background: #667eea;
    }
    
    /* Ensure media container aligns properly */
    .chat-text-box .media {
        display: flex;
        align-items: flex-end;
        width: 100%;
    }
    
    /* Date Separator */
    .date-separator {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 24px 0;
        gap: 12px;
    }
    
    .date-separator-line {
        flex: 1;
        height: 1px;
        background: #e5e7eb;
    }
    
    .date-separator-text {
        font-size: 0.75rem;
        color: #9ca3af;
        font-weight: 500;
        padding: 0 12px;
        white-space: nowrap;
    }
    
    /* Loading State */
    .chat-list-loading {
        animation: fadeIn 0.3s;
    }
    @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }
    
    /* Device Selector in Sidebar */
    .device-selector-header {
        padding: 0;
        background: white;
        border-bottom: 1px solid #e5e7eb;
        width: 100%;
    }
    
    .device-selector-header .dropdown {
        width: 100%;
        position: relative;
        display: block;
    }
    
    .device-selector-btn-sidebar {
        width: 100%;
        border: none;
        border-bottom: 1px solid #e5e7eb;
        color: #374151;
        background: white;
        padding: 0.75rem 1rem;
        font-size: 0.875rem;
        border-radius: 0;
        transition: all 0.2s;
        text-align: left;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
    }
    
    .device-selector-btn-sidebar:hover {
        background: #f9fafb;
        border-color: #4f46e5;
        color: #4f46e5;
    }
    
    .device-selector-btn-sidebar:focus {
        box-shadow: 0 0 0 0.2rem rgba(79, 70, 229, 0.25);
        outline: none;
    }
    
    .device-name-text {
        flex: 1;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 0 0.5rem;
    }
    
    .device-dropdown {
        width: 100%;
        min-width: 100%;
        max-height: 400px;
        overflow-y: auto;
        display: none;
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        z-index: 1000;
        margin-top: 0;
    }
    
    .device-dropdown.show {
        display: block;
    }
    
    .dropdown.show .device-dropdown {
        display: block;
    }
    
    .device-item {
        padding: 0.75rem 1rem;
        cursor: pointer;
        transition: background-color 0.2s;
    }
    
    .device-item:hover {
        background-color: #f8f9fa;
    }
    
    .device-item.active {
        background-color: #e7f3ff;
    }
    
    .device-item.active .font-weight-bold {
        color: #4f46e5;
    }
    
    .badge-sm {
        font-size: 0.75rem;
        padding: 0.25rem 0.5rem;
    }
    
    .device-dropdown .dropdown-header {
        font-size: 0.75rem;
        font-weight: 600;
        text-transform: uppercase;
        color: #6b7280;
        padding: 0.5rem 1rem;
    }
    
    /* Mobile Layout */
    @media (max-width: 767px) {
        .chat-fullscreen {
            padding: 0 !important;
            margin: 0 !important;
        }
        
        .chat-area-fullscreen {
            flex-direction: column;
            gap: 0;
            width: 100vw !important;
            margin: 0 !important;
            padding: 0 !important;
        }
        
        /* Full width chat container on mobile */
        .chat-area-fullscreen.mobile-chat-open {
            width: 100vw !important;
        }
        
        .chat-area-fullscreen.mobile-chat-open .tab-content {
            width: 100vw !important;
            margin: 0 !important;
            padding: 0 !important;
        }
        
        .chat-area-fullscreen.mobile-chat-open .chat {
            width: 100vw !important;
            margin: 0 !important;
            padding: 0 !important;
        }
        
        .chat-area-fullscreen.mobile-chat-open .chat-body {
            width: 100vw !important;
            margin: 0 !important;
            padding: 0 !important;
            border-radius: 0 !important;
            box-shadow: none !important;
        }
        
        /* Mobile Header */
        .mobile-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 12px 16px;
            background: #4f46e5;
            color: white;
            position: sticky;
            top: 0;
            z-index: 1000;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }
        
        .mobile-back-btn,
        .mobile-menu-btn {
            background: transparent;
            border: none;
            color: white;
            font-size: 1.25rem;
            padding: 8px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            min-width: 40px;
            height: 40px;
            border-radius: 8px;
            transition: background 0.2s;
        }
        
        .mobile-back-btn:hover,
        .mobile-menu-btn:hover {
            background: rgba(255, 255, 255, 0.1);
        }
        
        .mobile-chat-info {
            flex: 1;
            text-align: center;
            margin: 0 12px;
        }
        
        .mobile-chat-name {
            font-size: 1rem;
            font-weight: 600;
            margin: 0;
            color: white;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        
        .mobile-chat-number {
            font-size: 0.75rem;
            color: rgba(255, 255, 255, 0.9);
            display: block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        
        /* Mobile Sidebar */
        .chat-sidebar {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100vh;
            z-index: 9998;
            transform: translateX(-100%);
            transition: transform 0.3s ease;
            background: white;
        }
        
        .chat-sidebar.mobile-sidebar-open {
            transform: translateX(0) !important;
            display: block !important;
            visibility: visible !important;
        }
        
        /* Override display:none when mobile-chat-open is removed - higher specificity */
        .chat-area-fullscreen:not(.mobile-chat-open) .chat-sidebar.mobile-sidebar-open {
            display: block !important;
            transform: translateX(0) !important;
            visibility: visible !important;
        }
        
        /* Even higher specificity to override mobile-chat-open */
        .chat-area-fullscreen .chat-sidebar.mobile-sidebar-open {
            display: block !important;
        }
        
        /* Sidebar Overlay */
        .chat-sidebar::before {
            content: '';
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            z-index: -1;
            opacity: 0;
            /* transition: opacity 0.3s ease; */
            pointer-events: none;
        }
        
        .chat-sidebar.mobile-sidebar-open::before {
            opacity: 1;
            pointer-events: all;
        }
        
        /* Chat Main Content */
        .chat-main-content {
            width: 100% !important;
            min-width: 0;
        }
        
        .chat-area-fullscreen.mobile-chat-open .chat-sidebar {
            display: none !important;
        }
        
        /* Force sidebar to show when mobile-sidebar-open is true - MUST override display:none */
        /* Use highest specificity to override mobile-chat-open */
        .chat-area-fullscreen .chat-sidebar.mobile-sidebar-open {
            display: block !important;
            transform: translateX(0) !important;
            visibility: visible !important;
        }
        
        /* Additional override for when mobile-chat-open is removed */
        .chat-area-fullscreen:not(.mobile-chat-open) .chat-sidebar.mobile-sidebar-open {
            display: block !important;
            transform: translateX(0) !important;
            visibility: visible !important;
        }
        
        .mobile-sidebar-toggle {
            padding: 20px;
            text-align: center;
        }
        
        .mobile-sidebar-toggle .btn {
            width: 100%;
            max-width: 300px;
        }
        
        /* Chat Body Adjustments */
        .chat-body {
            border-radius: 0 !important;
            height: calc(100vh - 60px) !important; /* Subtract mobile header height */
            display: flex !important;
            flex-direction: column !important;
            overflow: visible !important; /* Changed from hidden to visible */
            width: 100vw !important;
            margin: 0 !important;
            padding: 0 !important;
            max-width: 100vw !important;
            position: relative !important;
        }
        
        /* Ensure chat-box doesn't overflow and footer is visible */
        .chat-body .chat-box {
            flex: 1 1 auto !important;
            min-height: 0 !important;
            overflow-y: auto !important;
            padding-bottom: 130px !important; /* Space for fixed footer */
        }
        
        /* Ensure footer is always visible and positioned correctly */
        .chat-body .chat-footer {
            position: fixed !important;
            bottom: 0 !important;
            left: 0 !important;
            right: 0 !important;
            z-index: 1000 !important;
            background: white !important;
            border-top: 1px solid #e5e7eb !important;
            flex-shrink: 0 !important;
            width: 100vw !important;
            max-width: 100vw !important;
            box-sizing: border-box !important;
            margin: 0 !important;
            padding: 8px 12px !important;
            display: block !important;
            visibility: visible !important;
            opacity: 1 !important;
            box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1) !important;
        }
        
        /* Add padding to chat-box to prevent content from being hidden behind footer */
        .chat-body .chat-box {
            padding-bottom: 130px !important;
        }
        
        .chat-header {
            border-radius: 0;
            padding: 12px 16px;
        }
        
        .chat-header.hide-on-mobile {
            display: none !important;
        }
        
        .chat-box {
            padding: 16px;
            flex: 1 !important;
            min-height: 0 !important;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
            width: 100% !important;
            box-sizing: border-box;
        }
        
        /* Override padding classes on mobile */
        .chat-box.mobile-chat-box {
            padding: 12px 16px !important;
        }
        
        .chat-bubble {
            max-width: 85%;
            font-size: 0.875rem;
        }
        
        .chat-footer {
            padding: 8px 12px !important;
            flex-shrink: 0 !important;
            position: fixed !important;
            bottom: 0 !important;
            left: 0 !important;
            right: 0 !important;
            z-index: 1000 !important;
            background: white !important;
            width: 100vw !important;
            max-width: 100vw !important;
            box-sizing: border-box !important;
            display: block !important;
            visibility: visible !important;
            opacity: 1 !important;
            margin: 0 !important;
            border-top: 1px solid #e5e7eb !important;
            box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1) !important;
        }
        
        /* Add padding to chat-box to prevent content from being hidden behind fixed footer */
        .chat-body .chat-box {
            padding-bottom: 130px !important;
        }
        
        /* Ensure CustomText component is visible */
        .chat-footer .w-100 {
            display: block !important;
            visibility: visible !important;
            width: 100% !important;
        }
        
        /* Avatar adjustments */
        .avatar-circle {
            width: 48px;
            height: 48px;
        }
        
        .avatar-initial-message {
            width: 40px;
            height: 40px;
            font-size: 0.7rem;
        }
        
        /* User list adjustments */
        .user-list-item {
            padding: 10px;
        }
        
        .search-header {
            padding: 12px;
        }
        
        .search-input {
            font-size: 0.875rem;
            padding: 10px 12px 10px 40px;
        }
        
        /* Device selector adjustments */
        .device-selector-btn-sidebar {
            padding: 0.625rem 0.875rem;
            font-size: 0.8125rem;
        }
        
        /* Date separator */
        .date-separator {
            margin: 16px 0;
            gap: 8px;
        }
        
        .date-separator-text {
            font-size: 0.7rem;
            padding: 0 8px;
        }
        
        /* Hide desktop-only elements */
        .chat-header .nav {
            display: none;
        }
    }
    
    /* Tablet adjustments */
    @media (min-width: 768px) and (max-width: 1024px) {
        .chat-sidebar {
            width: 35%;
            min-width: 280px;
        }
        
        .chat-bubble {
            max-width: 75%;
        }
    }

    .chat-image {
        max-width: 100%;
        max-height: 300px;
        border-radius: 12px;
        display: block;
        transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        object-fit: contain;
        background: rgba(0, 0, 0, 0.05);
    }

    .image-link {
        display: block;
        overflow: hidden;
        border-radius: 12px;
        margin-top: 4px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        border: 1px solid rgba(0, 0, 0, 0.05);
    }

    .image-link:hover .chat-image {
        transform: scale(1.02);
    }

    .incoming-bubble .chat-image {
        background: rgba(255, 255, 255, 0.1);
    }

    /* Modal Styles */
    .image-fullscreen-modal {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 10000;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 24px;
    }

    .modal-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.9);
        backdrop-filter: blur(5px);
    }

    .modal-content-wrapper {
        position: relative;
        z-index: 1;
        max-width: 90%;
        max-height: 90%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .modal-image-fullscreen {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        border-radius: 8px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
    }

    .modal-close-btn {
        position: absolute;
        top: -40px;
        right: -40px;
        background: transparent;
        border: none;
        color: white;
        font-size: 24px;
        cursor: pointer;
        padding: 10px;
        transition: transform 0.2s;
    }

    .modal-close-btn:hover {
        transform: scale(1.2);
    }

    @media (max-width: 767px) {
        .modal-close-btn {
            top: -50px;
            right: 0;
        }
    }

    /* Image Bubble specific */
    .chat-bubble.image-bubble {
        padding: 0;
        overflow: hidden;
        cursor: pointer;
        border-radius: 12px;
        background: transparent;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
        border: 1px solid rgba(0, 0, 0, 0.08);
        max-width: 300px; /* Fixed max width for images to look consistent */
    }

    .chat-bubble.image-bubble .chat-image {
        width: 100%;
        max-height: 400px;
        margin: 0;
        display: block;
        object-fit: cover;
    }

    .outgoing-bubble.image-bubble {
        border-color: #ccedaa;
    }

    .image-caption {
        padding: 8px 12px;
        margin: 0;
        font-size: 14.5px;
        line-height: 1.5;
        color: inherit;
        background: transparent;
        white-space: pre-line;
    }

    .incoming-bubble.image-bubble .image-caption,
    .incoming-bubble.file-card-bubble .image-caption {
        color: #1f2937;
        border-top: 1px solid #f3f4f6;
    }

    .outgoing-bubble.image-bubble .image-caption,
    .outgoing-bubble.file-card-bubble .image-caption {
        color: #1f2937;
        border-top: 1px solid #ccedaa;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.3s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    /* File Card Styles */
    .file-card-bubble {
        padding: 0 !important;
        overflow: hidden;
        border-radius: 12px;
        min-width: 260px;
        max-width: 320px;
    }

    .file-preview-wrapper {
        border-top: 1px solid rgba(0, 0, 0, 0.05);
        width: 100%;
    }

    .file-card-bubble.chat-bubble .file-preview-wrapper {
        border-top: none;
    }

    .file-card {
        display: flex;
        align-items: center;
        padding: 12px;
        text-decoration: none;
        color: inherit;
        background: rgba(0, 0, 0, 0.02);
        transition: all 0.2s ease;
        gap: 12px;
        width: 100%;
    }

    .file-card:hover {
        background: rgba(0, 0, 0, 0.05);
        text-decoration: none;
        color: inherit;
        transform: translateY(-1px);
    }

    .file-card-icon {
        width: 44px;
        height: 44px;
        background: white;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        flex-shrink: 0;
        box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    }

    .file-card-details {
        flex: 1;
        min-width: 0;
    }

    .file-card-name {
        font-size: 13.5px;
        font-weight: 600;
        color: #1f2937;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 2px;
    }

    .file-card-size {
        font-size: 11px;
        color: #6b7280;
        font-weight: 500;
    }

    .file-card-action {
        color: #9ca3af;
        font-size: 14px;
        padding: 4px;
        transition: color 0.2s;
    }

    .file-card:hover .file-card-action {
        color: #4f46e5;
    }

    .outgoing-bubble .file-card {
        background: rgba(0, 0, 0, 0.03);
    }

    .outgoing-bubble .file-card-name {
        color: #064e3b;
    }

    /* Message Text with File Adjustment */
    .chat-bubble .message-text:has(+ .file-preview-wrapper) {
        padding-bottom: 4px;
    }

    /* .incoming-bubble .message-text {
        padding: 12px 16px;
    }

    .outgoing-bubble .message-text {
        padding: 12px 16px;
    } */

    /* Override previous padding if it's a file card bubble */
    .chat-bubble.file-card-bubble .message-text {
        padding: 12px 16px 8px 16px;
    }
</style>
